<template>
    <v-row>
        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.nombre" :label="$t('cobrox.compra.labels.nombre')" icon="description"/>
                 <show-field :value="String(item.porcentajeCompra)" :label="$t('cobrox.compra.labels.porcentajeCompra')" icon="donut_small"/>
                 <show-field :value="String(item.orden)" :label="$t('cobrox.compra.labels.orden')" icon="sort"/>
                 <show-field :value="item.estrategiaLiquidacion || 'TRADICIONAL'" :label="$t('cobrox.compra.labels.estrategiaLiquidacion')" icon="account_balance"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.nombreLegal" :label="$t('cobrox.compra.labels.nombreLegal')" icon="verified"/>
                 <show-field :value="item.cuit" :label="$t('cobrox.compra.labels.cuit')" icon="business"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="getDateFormat(item.fechaCompra)" :label="$t('cobrox.compra.labels.fechaCompra')" icon="event"/>
                 <show-field :value="item.direccionLegal" :label="$t('cobrox.compra.labels.direccionLegal')" icon="location_on"/>
                 <show-field v-if="item.estrategiaLiquidacion === 'POR_VUELTA'" :value="comisionPorVuelta" :label="$t('cobrox.compra.labels.comisionPorVuelta')" icon="percent"/>
            </v-list>
        </v-col>

    </v-row>
</template>
<script>
    import {ShowField} from '@dracul/common-frontend'
    import {DayjsMixin} from "@dracul/dayjs-frontend"; 
    
    export default {
        name: 'CompraShowData',
        components: {ShowField},
        mixins: [DayjsMixin],
        props: {
            item: {type: Object, required: true}
        },
        computed: {
            comisionPorVuelta() {
                const comision = this.normalizeComisionPorVuelta(this.item.comisionPorVuelta)
                return comision
                    .map(item => `${this.$t('cobrox.compra.labels.vuelta')} ${item.numeroVuelta}: ${item.porcentaje || 0}%`)
                    .join(' | ')
            }
        },
        methods: {
            normalizeComisionPorVuelta(comisionPorVuelta) {
                if (Array.isArray(comisionPorVuelta)) return comisionPorVuelta
                if (!comisionPorVuelta) return []
                return [
                    {numeroVuelta: 1, porcentaje: comisionPorVuelta.vuelta1},
                    {numeroVuelta: 2, porcentaje: comisionPorVuelta.vuelta2},
                    {numeroVuelta: 3, porcentaje: comisionPorVuelta.vuelta3},
                    {numeroVuelta: 4, porcentaje: comisionPorVuelta.vuelta4Mas}
                ].filter(item => item.porcentaje !== null && item.porcentaje !== undefined && item.porcentaje !== '')
            }
        }
    }
</script>
